import { chordStore } from '@/store/chordStore'

const hookTheoryEndpoint = 'https://api.hooktheory.com/v1/trends'
const apiToken = '1861c524fabff5b8db94b44327645223'

// This populates the chordStore.compatibleChords with the top 10 chords
export const getAllChords = async () => {
  chordStore.loadingChords = true
  const response = await fetch(`${hookTheoryEndpoint}/nodes`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${apiToken}`
    }
  })

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const allCompatibleChords = await response.json()
  const topTenCompatibleChords = allCompatibleChords.slice(0, 10)
  chordStore.compatibleChords = topTenCompatibleChords
  chordStore.loadingChords = false
}

// This clears chordStore.compatibleChords
export const clearCompatibleChords = () => {
  chordStore.compatibleChords = []
}

// This accepts the chordStore.chordProgression array and returns compatible chords
export const getCompatibleChords = async (chords) => {
  chordStore.loadingChords = true;
  try {
    const response = await fetch(`${hookTheoryEndpoint}/nodes?cp=${chords}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiToken}`
      }
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const responseText = await response.text();
    try {
      const allCompatibleChords = JSON.parse(responseText);
      const topTenCompatibleChords = allCompatibleChords.slice(0, 10);
      chordStore.compatibleChords = topTenCompatibleChords;
    } catch (jsonError) {
      console.error("Error parsing JSON:", jsonError);
      console.log("Raw response:", responseText);
      throw new Error("Failed to parse JSON response");
    }
  } catch (error) {
    console.error("Error fetching compatible chords:", error);
  } finally {
    chordStore.loadingChords = false;
  }
};


// This adds the selected chord to the chord
export const addToProgression = async (chordID, chordHTML) => {
  chordStore.chordProgression.push({ chordID: chordID, chordHTML: chordHTML })
  const chordIdList = chordStore.chordProgression.map(chord => chord.chordID).join(',')
  console.log(chordIdList)
  // Then it refreshes the chordStore.compatibleChords based on
  // the updated progression thus far
  getCompatibleChords(chordIdList)
  getSimilarSongs()
}

export const getSimilarSongs = async () => {
  // Here's where we could set loadingSimilarSongs = true
  const chordIdList = chordStore.chordProgression.map(chord => chord.chordID).join(',')
  try {
    const response = await fetch(`${hookTheoryEndpoint}/songs?cp=${chordIdList}`, {
      method: 'GET',
      headers: {
        'ContentType': 'application/json',
        'Authorization': `Bearer ${apiToken}`
      }
    })
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const similarSongs = JSON.parse(await response.text())

    // This function uses reduce() to create a new array that only includes the first occurrence of each song
    const similarSongsWithoutDuplicates = await similarSongs.reduce((acc, item) => {
      if (!acc.some(accItem => accItem.song === item.song)) acc.push(item)
      return acc
    }, [])

    chordStore.similarSongs = similarSongsWithoutDuplicates
  } catch (error) {
    console.error(error)
  } finally {
    // Here's where we could set loadingSimilarSongs = false
  }
}
